import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h1 _mt-6 _mb-5" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-card-list gfu-card-list--wrap _-mt-3"
}
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = { class: "_mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_user_profile_card = _resolveComponent("user-profile-card")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.Resources.Profile.SectionFollowingHeader), 1 /* TEXT */),
    (_ctx.hasPagedItems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedItems, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.urlName,
              class: "gfu-card-list__item gfu-1of1 gfu-1of3--l gfu-1of3--xl",
              "data-qa": `user-card-urlname:${item.urlName}`
            }, [
              _createVNode(_component_user_profile_card, _mergeProps({ ref_for: true }, item), null, 16 /* FULL_PROPS */)
            ], 8 /* PROPS */, _hoisted_4))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createBlock(_component_box, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_empty_state, {
              title: _ctx.Resources.Profile.EmptyStateFollowingTitle,
              "data-qa": "user-profile:EmptyState"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.Resources.Profile.EmptyStateFollowingParagraph), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"])
          ]),
          _: 1 /* STABLE */
        })),
    (_ctx.hasMorePagedItems)
      ? (_openBlock(), _createBlock(_component_load_more_trigger, {
          key: 2,
          onLoadMore: $options.onLoadMore
        }, null, 8 /* PROPS */, ["onLoadMore"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}